<template>
  <div class="batch-card-header">
    <div
      :id="`batch-card-header-label-${index}`"
      class="batch-card-header-row"
    >
      <span class="batch-card-header-label">Lote:</span>

      <span class="batch-card-header-mnemonic">{{ mnemonic }}</span>
    </div>

    <div
      :id="`batch-card-header-barcode-${index}`"
      class="batch-card-header-row"
    >
      <span class="batch-card-header-label">Código:</span>
      {{ barcode ?? '-' }}
    </div>

    <div
      :id="`batch-card-header-date-${index}`"
      class="batch-card-header-row"
    >
      <span class="batch-card-header-label">Data:</span>
      {{ creationDate | date }}
    </div>

    <div
      v-if="$toggle.feature.collectPlace && collectionPointHasValidValue"
      :id="`batch-card-header-collectionPoint-${index}`"
      class="batch-card-header-row ellipsable"
    >
      <span class="batch-card-header-label">Posto:</span>

      <span>
        {{ collectionPlaceName }}

        <md-tooltip md-direction="top">
          Posto de coleta: {{ collectionPlaceName }}
        </md-tooltip>
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { COLLECTION_POINT_EMPTY_DEFAULT_VALUE } from '@/enums'

export default {
  name: 'BatchCardHeader',
  filters: {
    date(value) {
      return moment(value).format('DD-MM-YYYY')
    },
  },
  props: {
    label: {
      type: [String, Number],
      default: 0,
    },
    sequence: {
      type: String,
    },
    barcode: {
      type: String,
    },
    creationDate: {
      type: [String, Date],
    },
    index: {
      type: Number,
      default: 0,
    },
    collectionPlaceName: {
      type: String,
    },
  },
  computed: {
    collectionPointHasValidValue() {
      return (
        this.collectionPlaceName &&
        this.collectionPlaceName !== COLLECTION_POINT_EMPTY_DEFAULT_VALUE
      )
    },
    mnemonic() {
      return this.label && this.sequence ? `${this.label}.${this.sequence}` : 'Aguardando'
    },
  },
}
</script>

<style lang="scss" scoped>
.batch-card-header {
  color: #7a7a7a;
  font-size: 11px;
  letter-spacing: 0.5px;
  opacity: 1;
  line-height: 16px;
  flex: 80%;
  min-width: 0;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  &-label {
    font-weight: 700;
    text-transform: uppercase;
  }

  &-mnemonic {
    background-color: #4a4a4a;
    border-radius: 2px;
    color: white;
    padding: 1px 6px;
    font-family: 'Exo 2';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    opacity: 0.93;
    text-transform: uppercase;
    display: inline-flex;
  }

  &-row {
    &.ellipsable {
      max-width: 12rem;
    }
  }
}
</style>
